import { Grid, Paper, Skeleton } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() =>
  createStyles({
    skeletonPaper: {
      width: '100%',
      padding: 16,
      borderRadius: 5,
      backgroundColor: '#F1F3F4',
      borderColor: '#dadada',
      borderStyle: 'solid',
      borderWidth: 1,
      marginBottom: 8,
    },
    skeletonKeywords: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }),
);

export default function SearchResultsSkeleton() {
  const classes = useStyles();

  const RoundedSkeleton = (props) => (
    <Skeleton
      {...props}
      variant="rectangular"
      height={40}
      width={props.i * 40}
      style={{ borderRadius: 20 }}
    />
  );

  return (
    <>
      {Array.from(Array(10)).map((field, i) => (
        <Paper className={classes.skeletonPaper} elevation={0} key={i}>
          <Grid container style={{ width: '100%' }}>
            <Grid item sm={12}>
              <Skeleton
                variant={'text'}
                height={20}
                style={{ maxWidth: 250 }}
              />
            </Grid>
            <Grid container item sm={12}>
              <Grid sm={6}>
                <Skeleton
                  variant={'text'}
                  height={20}
                  style={{ maxWidth: 280 }}
                />
              </Grid>
              <Grid sm={6}>
                <Skeleton
                  variant={'text'}
                  height={20}
                  style={{ maxWidth: 120 }}
                />
              </Grid>
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={12} style={{ marginBottom: 8 }}>
                <Skeleton
                  variant={'text'}
                  height={20}
                  style={{ maxWidth: 100 }}
                />
              </Grid>
              {Array.from(Array(6)).map((field, i) => (
                <Grid item xs={12} sm={6} style={{ padding: 2 }} key={i + 7}>
                  <RoundedSkeleton i={Math.ceil((i + 2) * Math.random())} />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Paper>
      ))}
    </>
  );
}
